<template>
  <div>
    <modal-invalid-ingredients />
    <modal-unavailable-ingredients />
    <modal-recotized-limits />
    <div class="order-new">
      <div
        v-if="step === 'form'"
        class="order-new__form-content"
      >
        <div class="order-new__form">
          <div class="order-new__user-info">
            <user-info-form
              :email="email"
              :name="name"
              :surname="surname"
              :phone1="phone1"
              :phone2="phone2"
              :baddresses="baddresses"
              :preferred-billing-name="modifyOrder && modifyOrder.billing_name"
            />
          </div>
          <map-form
            :addresses="deliveryAddressesForForm"
            :preferred-address-name="modifyOrder && modifyOrder.address_name"
            enable-create
          />
          <div class="order-new__formula-name">
            <h3 class="order-new__subtitle">
              Nombre de la fórmula
            </h3>
            <input
              class="input order-new__single-input"
              :value="formulaName"
              @input="updateFormulaName"
              placeholder="Asignale un nombre a tu fórmula (opcional)"
              name="formulaName"
            >
            <h3 class="order-new__subtitle">
              Estado fisiológico
            </h3>
            <ev-select
              class="order-new__location-name-dropdown"
              style="margin-bottom: 1rem"
              v-model="physiologicalState"
              :options="physiologicalOptions"
              placeholder="Seleccione estado fisiológico"
              :on-change="value => physiologicalState = value"
            />
          </div>
          <div class="order-new__calendar">
            <h3 class="order-new__subtitle">
              Selecciona la fecha estimada de entrega
            </h3>
            <date-form />
            <div class="order-new__calendar-disclaimer">
              Los pedidos urgentes tendrán un cobro extra
            </div>
          </div>
        </div>
        <div class="order-new__resume">
          <h2
            v-if="!isCoagraWeb"
            class="order-new__resume-title"
          >
            Valor a pagar
          </h2>
          <span
            v-if="!isCoagraWeb"
            class="order-new__resume-payment-subtitle"
          >
            Valor neto <currency :value="netValue" /> x kg
          </span>
          <div class="order-new__resume-items">
            <amount-payable
              v-if="!isCoagraWeb"
              class="order-new__resume-details"
            />
            <div class="order-new__button">
              <div
                class="info"
                v-if="!isValidOrder"
              >
                Para continuar tienes que haber <br>
                ingresado toda la información requerida
              </div>
              <button
                @click="goToConfirm"
                class="btn order-new__button-confirm"
                :disabled="!isValidOrder"
              >
                Confirmar orden
              </button>
              <a
                href="/"
                class="order-new__back"
                data-turbolinks="false"
              >
                Página anterior
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="order-new__confirmation-content"
      >
        <confirmation
          :email="email"
          @back="goToForm"
        />
      </div>
    </div>
  </div>
</template>
<script>
import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import moment from 'moment';
import evSelect from '../ev-select.vue';
import amountPayable from './amount-payable.vue';
import userInfoForm from './user-info-form.vue';
import mapForm from '../map-form.vue';
import dateForm from './date-form.vue';
import confirmation from './confirmation.vue';
import modalInvalidIngredients from '../modal-invalid-ingredients';
import modalUnavailableIngredients from '../modal-unavailable-ingredients';
import modalRecotizedLimits from '../modal-recotized-limits.vue';
import currency from '../../tools/currency';
import productTons from '../product-tons';
import baggedOrder from '../formulator/bagged-order';

const PERCENTAGE_TOLERANCE = 2;

export default {
  components: {
    amountPayable,
    userInfoForm,
    mapForm,
    dateForm,
    confirmation,
    modalInvalidIngredients,
    modalUnavailableIngredients,
    modalRecotizedLimits,
    evSelect,
    currency,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    surname: {
      type: String,
      default: '',
    },
    phone1: {
      type: String,
      default: '',
    },
    phone2: {
      type: String,
      default: '',
    },
    credit: {
      type: String,
      default: '',
    },
    baddresses: {
      type: Array,
      default: () => [],
    },
    deliveryAddresses: {
      type: Array,
      default: () => [],
    },
    ingredientsProp: {
      type: Array,
      default: () => [],
    },
    sackServicePrice: {
      type: String,
      default: '0',
    },
    commission: {
      type: String,
      default: '0.05',
    },
    coagraFormulator: {
      type: Boolean,
      default: false,
    },
    colunFormulator: {
      type: Boolean,
      default: false,
    },
    isColunContext: {
      type: Boolean,
      default: false,
    },
    isCoagraContext: {
      type: Boolean,
      default: false,
    },
    inverseRecipe: {
      type: Object,
      default: undefined,
    },
    product: {
      type: Object,
      default: undefined,
    },
    dateAvailabilityAndFees: {
      type: Object,
      required: true,
    },
    form: {
      type: String,
      default: undefined,
    },
    packaging: {
      type: String,
      default: undefined,
    },
    via: {
      type: String,
      default: undefined,
    },
    customName: {
      type: String,
      default: undefined,
    },
    totalSackWeight: {
      type: String,
      default: undefined,
    },
    selectedTons: {
      type: [Number, String],
      default: 15,
    },
    settingsLimits: {
      type: Object,
      default: () => ({}),
    },
    modifyOrder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      sackService: { value: false, label: 'No' },
      step: 'form',
    };
  },
  beforeMount() {
    this.$store.dispatch('updateContactUserInfo', { creditAllowed: this.credit === 'true' });
    this.$store.dispatch('updateSackServiceBasePrice', this.sackServicePrice);
    this.$store.dispatch('updateIsCoagraWeb', {
      isCoagraWeb: this.coagraFormulator || this.isCoagraContext,
    });
    this.$store.dispatch('updateIsColunWeb', { isColunWeb: this.colunFormulator || this.isColunContext });
    this.$store.dispatch('setDateAvailabilityAndFees', this.dateAvailabilityAndFees);
    this.$store.commit('updateCommission', this.commission);
    this.$store.commit('updateSettingsLimits', {
      ...this.$store.state.settingsLimits,
      ...this.settingsLimits,
    });
    this.saveProductOrFormulatorOrderParams();
    this.applyModifyOrderPrefill();
  },
  methods: {
    applyModifyOrderPrefill() {
      if (!this.modifyOrder) return;

      const originalAmount = Number(this.modifyOrder.amount)
        || Number(this.modifyOrder.amount_estimated)
        || 0;
      let paidAmount = Number(this.modifyOrder.paid_amount) || 0;
      const paymentCompleted = !!this.modifyOrder.payment_completed;
      if (paidAmount <= 0 && paymentCompleted) {
        paidAmount = originalAmount;
      }

      this.$store.commit('updateModifyOrderId', this.modifyOrder.id);
      this.$store.commit('updateOriginalAmount', originalAmount);
      this.$store.commit('updatePaidAmount', paidAmount);
      this.$store.commit('updatePaymentCompleted', paymentCompleted);
      if (this.modifyOrder.custom_name) {
        this.$store.dispatch('updateFormulaName', this.modifyOrder.custom_name);
      }
      if (this.modifyOrder.delivery_date && !this.originalDeliveryDateUnavailable()) {
        this.$store.dispatch('updateDate', this.modifyOrder.delivery_date);
      }
    },
    saveProductOrFormulatorOrderParams() {
      if (this.product) {
        this.$store.dispatch('setProductDetails', {
          ...this.product,
          selected_tons: productTons.positiveTons(this.selectedTons, 15),
        });
        // Recotizar: el catálogo pone product.name; preferir el nombre del pedido.
        if (this.customName) {
          this.$store.dispatch('updateFormulaName', this.customName);
        }
      } else {
        this.setOrderParams();
      }
    },
    findPackagingFromParams() {
      return baggedOrder.resolveOrderPackaging(
        this.packaging,
        this.totalSackWeight,
        this.$store.getters.extendedPackagingList,
        this.$store.getters.productPackagingList,
      );
    },
    setOrderParams() {
      const form = this.$store.getters.allTranslatedForms.find(e => e.value === this.form);
      const packaging = this.findPackagingFromParams();

      this.$store.dispatch('updateForm', form);
      this.$store.commit('updatePackaging', packaging);
      this.$store.commit('updateVia', this.via);
      this.$store.dispatch('setIngredients', this.ingredientsProp);
      if (this.customName) this.$store.dispatch('updateFormulaName', this.customName);
      if (this.totalSackWeight) this.$store.commit('updateTotalSackWeight', this.totalSackWeight);
      this.validateAndSaveRecipe();
    },
    goToConfirm() {
      this.step = 'confirm';
    },
    goToForm() {
      this.step = 'form';
    },
    urlIngredientPercentagesWithinRange(urlIngredients) {
      const ingredients = keyBy(values(this.ingredients), ({ id }) => id);
      let ingredientsValidated = true;
      urlIngredients.forEach((urlIngredient) => {
        const ingredientPercentage = Number(urlIngredient.value);
        const maxPercentage = Number(ingredients[urlIngredient.id].max) + PERCENTAGE_TOLERANCE;
        const minPercentage = Number(ingredients[urlIngredient.id].min) - PERCENTAGE_TOLERANCE;
        if (ingredientPercentage > maxPercentage || ingredientPercentage < minPercentage) {
          ingredientsValidated = false;
        }
      });

      return ingredientsValidated;
    },
    validateAndSaveRecipe() {
      const queryIngredientsArray = Array.from(new URLSearchParams(window.location.search).entries())
        .reduce((ingredients, [key, value]) => {
          const ingredientIdMatch = key.match(/^ingredients_proportion\[(.+)\]$/);
          if (ingredientIdMatch) {
            ingredients.push({ id: ingredientIdMatch[1], value });
          }
          return ingredients;
        }, []);
      if (!this.allUrlIngredientsAreFormulatorIngredients(queryIngredientsArray)) {
        this.displayModal('unavailable-ingredients-modal');
      } else if (this.inverseRecipe?.details) {
        if (this.recotizedFormulaExceedsLimits(queryIngredientsArray)) {
          this.displayModal('recotized-limits-modal');
        } else {
          this.$store.dispatch('saveFormulaRecipe', this.inverseRecipe.details);
        }
      } else if (this.urlIngredientPercentagesWithinRange(queryIngredientsArray)) {
        this.$store.dispatch('saveFormulaRecipe', this.inverseRecipe?.details);
      } else {
        this.displayModal('invalid-ingredients-modal');
      }
    },
    // validateAndSaveRecipe corre desde beforeMount (vía setOrderParams), antes de
    // que los hijos <modal-*> se monten y se registren en vue-js-modal. Llamar a
    // $modal.show en ese momento es un no-op; diferimos a $nextTick para que el
    // modal ya exista cuando lo abrimos.
    displayModal(name) {
      this.$nextTick(() => this.$modal.show(name));
    },
    recotizedFormulaExceedsLimits(urlIngredients) {
      return !this.urlIngredientPercentagesWithinRange(urlIngredients) ||
        this.categoryTotalsExceedLimits(urlIngredients);
    },
    categoryTotalsExceedLimits(urlIngredients) {
      const isPellet = this.$store.getters.pelletForms.includes(
        this.$store.state.recipe.finishing.form.value,
      );
      if (!isPellet && !this.isCoagraWeb) return false;

      const ingredientsById = keyBy(values(this.ingredients), ({ id }) => id);
      const limits = this.settingsLimits;

      const totalFor = (category) => urlIngredients
        .filter(({ id }) => ingredientsById[id]?.category === category)
        .reduce((sum, { value }) => sum + Number(value), 0);

      if (limits.fibrous_ingredients_limit > 0 && totalFor('floured') > limits.fibrous_ingredients_limit) {
        return true;
      }
      if (limits.protein_ingredients_limit > 0 && totalFor('protein') > limits.protein_ingredients_limit) {
        return true;
      }
      return false;
    },
    resetScroll() {
      window.scrollTo(0, 0);
    },
    updateFormulaName(e) {
      this.$store.dispatch('updateFormulaName', e.target.value);
    },
    updateSackServicePrice(e) {
      if (e.value) {
        const sackServicePrice = this.$store.getters.sackServiceBasePrice * this.$store.state.recipe.weight;

        this.$store.dispatch('updateSackDischargeService', sackServicePrice);
      } else {
        this.$store.dispatch('updateSackDischargeService', 0);
      }
    },
    allUrlIngredientsAreFormulatorIngredients(urlIngredients) {
      const urlIngredientIds = urlIngredients
        .map(ingredient => Number(ingredient.id))
        .filter(id => !isNaN(id));
      const allValid = urlIngredientIds.every((urlIngredientId) =>
        this.formulatorIngredientIds.includes(urlIngredientId)
      );
      return allValid;
    },
    originalDeliveryDateUnavailable() {
      const original = this.modifyOrder && this.modifyOrder.delivery_date;
      const disabledDates = (this.dateAvailabilityAndFees && this.dateAvailabilityAndFees.disabled_dates) || [];
      if (!original) return false;

      const originalDay = moment(original).format('YYYY-MM-DD');
      return disabledDates.some(disabled => moment(disabled).format('YYYY-MM-DD') === originalDay);
    },
  },
  computed: {
    isValidOrder() {
      return this.$store.getters.isValidOrder;
    },
    ingredients() {
      return this.$store.state.ingredients;
    },
    formulatorIngredientIds() {
      return this.$store.getters.formulatorIngredients.map(({ id }) => id);
    },
    formulaName() {
      return this.$store.state.order.formulaName;
    },
    finishingType() {
      return this.$store.getters.orderItemFinishingType;
    },
    isBagged25() {
      const packaging = this.finishingType?.packaging?.value;

      return packaging === 'bagged25' || (!!packaging && packaging.startsWith('bagged25_'));
    },
    orderWeight() {
      return this.$store.state.recipe.weight;
    },
    isCoagraWeb() {
      return this.$store.state.order.isCoagraWeb;
    },
    netValue() {
      return this.$store.getters.netTotal / this.orderWeight;
    },
    physiologicalState: {
      get() { return this.$store.state.order.physiologicalState; },
      set(value) { this.$store.dispatch('updatePhysiologicalState', value); }
    },
    deliveryAddressesForForm() {
      const addresses = [...(this.deliveryAddresses || [])];
      if (!this.modifyOrder) return addresses;

      const exists = addresses.some(address => address.name === this.modifyOrder.address_name);
      if (!exists && this.modifyOrder.address_name) {
        const coords = this.modifyOrder.address_coords || {};
        addresses.unshift({
          name: this.modifyOrder.address_name,
          lat: coords.lat,
          lng: coords.lng,
          reference: this.modifyOrder.address_reference,
        });
      }
      return addresses;
    },
    physiologicalOptions() {
      return [
        { value: 'Vacas en lactancia', label: 'Vacas en lactancia' },
        { value: 'Vacas en transición', label: 'Vacas en transición' },
        { value: 'Terneros iniciales', label: 'Terneros iniciales' },
        { value: 'Terneros en crecimiento', label: 'Terneros en crecimiento' },
        { value: 'Novillos en engorda', label: 'Novillos en engorda' }
      ];
    },
  },
  watch: {
    step: 'resetScroll',
    'finishingType.form.value': {
      handler(newVal) {
        const map = {
          pellet3: 'Terneros iniciales',
          pellet6: 'Terneros en crecimiento',
          pellet8: 'Vacas en lactancia',
          pellet12: 'Vacas en lactancia',
          powder: 'Vacas en lactancia',
          multiparticle: 'Vacas en lactancia',
          whole: 'Vacas en lactancia',
        };
        if ( map[newVal]) {
          console.log('setting physiological state');
          this.physiologicalState = { value: map[newVal], label: map[newVal] };
        }
      },
      immediate: true
    }
  },
};
</script>
